// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ArrowheadMarquee(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ArrowheadMarquee" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M3 9H5V13H3V9Z", fill: "currentColor" }),
            React.createElement("path", { d: "M19 8H21V12H19V8Z", fill: "currentColor" }),
            React.createElement("path", { d: "M10 2H14V4H10V2Z", fill: "currentColor" }),
            React.createElement("path", { d: "M3 2L3 7H5L5 4L8 4V2L3 2Z", fill: "currentColor" }),
            React.createElement("path", { d: "M21 2L16 2V4H19V6H21V2Z", fill: "currentColor" }),
            React.createElement("path", { d: "M3 20H9V18H5L5 15H3V20Z", fill: "currentColor" }),
            React.createElement("path", { d: "M9.16422 7.14103L11.6296 22.3784L14.7032 15.8067L21.5346 15.6653L9.16422 7.14103Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ArrowheadMarquee.js.map